//mypreset.ts
import { definePreset } from '@primeng/themes';
import Aura from '@primeng/themes/aura';

const ExcuelaPreset = definePreset(Aura, {
    semantic: {
        primary: {
            50: '{blue.50}',
            100: '{blue.100}',
            200: '{blue.200}',
            300: '{blue.300}',
            400: '{blue.400}',
            500: '{blue.500}',
            600: '{blue.600}',
            700: '{blue.700}',
            800: '{blue.800}',
            900: '{blue.900}',
            950: '{blue.950}'
        }
    },
    components: {
        button: {
            colorScheme: {
                light: {
                    root: {
                       primary: {
                        background: '{blue.900}',
                        color: '{blue.50}',
                        borderColor: '{blue.900}'
                       }
                    }
                },
                dark: {
                    root: {
                        primary: {
                            background: '{blue.900}',
                            color: '{blue.50}'
                        }
                    }
                }
            }
        },
        paginator: {
            colorScheme: {
                light: {
                    navButton: {
                        selectedBackground: '{blue.800}',
                        selectedColor: '{blue.50}',
                        borderRadius: '12px'
                    }
                }
            }
        }
                    
    }
});

export default ExcuelaPreset;